import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import WebApp from "@twa-dev/sdk";

let lang = WebApp.initDataUnsafe.user?.language_code ?? "en";
// split the language from region code
lang = lang.split(/[-_]/)[0];

i18n.use(initReactI18next).init({
    resources: {
        ru: {
            translation: {
                "ask_me_anything": "Спросите меня что-нибудь",
                "ask_me_anything_owner": "Задать вопрос себе",
                "ask_me_anything_footer": "Когда {{first_name}} ответит на ваш вопрос, он появится в списке ответов.",
                "ask_me_anything_footer_owner": "Вы найдёте свой вопрос на вкладке вопросов",
                "question_placeholder": "Напишите свой вопрос здесь",
                "send_anonymous": "Отправить анонимно",
                "send": "Отправить",
                "answers": "Ответы",
                "questions": "Вопросы ",
                "no_answers_yet": "Пока нет ответов",
                "no_answers_yet_description": "Когда {{first_name}} ответит на какой-нибудь вопрос, ответ появится здесь.",
                "no_answers_yet_description_owner": "Отправьте ссылку на свой профиль друзьям, чтобы они могли задать вам вопросы.",
                "no_questions_yet": "Пока нет вопросов",
                "no_questions_yet_description": "Вы пока не задавали вопросов этому пользователю.",
                "no_questions_yet_description_owner": "Пока нет вопросов. Поделитесь ссылкой на свой профиль, чтобы ваши друзья могли задать вам вопросы.",
                "ask_question_action": "Задать вопрос",
                "send_link_action": "Отправить ссылку",
                "share_link_action": "Поделиться ссылкой",
                "answer": "Ответить",
                "answer_placeholder": "Напишите свой ответ здесь",
                "delete": "Удалить",
                "cancel": "Отмена",
                "go_to_my_profile": "Перейти в мой профиль",
                "open_profile": "Открыть профиль",
                "cancel_answer": "Отменить ответ",
                "delete_question": "Удалить вопрос",
                "question_sent": "Вопрос отправлен",
                "question_send_error": "Ошибка отправки вопроса",
                "answer_sent": "Ответ отправлен",
                "answer_send_error": "Ошибка отправки ответа",
                "question_deleted": "Вопрос удалён",
                "question_delete_error": "Ошибка удаления вопроса",
                "answer_cancelled": "Ответ отменён",
                "answer_cancel_error": "Ошибка отмены ответа",
                "delete_question_confirmation": "Вы уверены, что хотите удалить этот вопрос?",
                "withdraw_answer_confirmation": "Вы уверены, что хотите отозвать ответ?",
                "withdraw_answer_action": "Отозвать",
                "cancel_title": "Отзыв ответа",
                "delete_title": "Удаление вопроса",
                "profile_loading_error": "Ошибка загрузки профиля 😔",
                "should_try_reload": "Попробуйте перезагрузить приложение",
                "repeat": "Повторить",
                "share_profile_owner_text": "По ссылке вы можете задать мне анонимный вопрос!",
                "share_profile_text": "По ссылке вы можете задать анонимный вопрос!\n{{first_name}} {{last_name}}",
                "anonymous": "Аноним",
                "questions_from_you": "Здесь отображаются вопросы, заданные вами",
                "update_profile_photo_title": "Обновить фото профиля",
                "save_photo": "Сохранить фото",
                "profile_photo_updated": "Фото профиля обновлено",
                "profile_photo_update_error": "Ошибка обновления фото профиля",
                "select_file": "Выберите файл",
                "unknown_error": "Неизвестная ошибка",
                "share_answer": "Поделиться ответом",
                "sent": "Отправлено",
                "answer_from_bot": "Ответ из @askerixbot",
                "subscribe": "Подписаться",
                "unsubscribe": "Отписаться",
                "subscribed": "Вы подписаны на уведомления о новых ответах пользователя",
                "unsubscribed": "Вы отписаны от уведомлений о новых ответах пользователя",
                "still_not_answered": "{{first_name}} ещё думает, что ответить",
                "asked_questions": "Заданные вами вопросы",
                "function_not_supported": "Функция пока не поддерживается на вашем устройстве",
                "sent_by_bot": "Отправлено в сообщении от бота",
            }
        },
        en: {
            translation: {
                "ask_me_anything": "Ask me anything",
                "ask_me_anything_owner": "Ask yourself a question",
                "ask_me_anything_footer": "When {{first_name}} answers your question, it will appear in the answers list.",
                "ask_me_anything_footer_owner": "You will find your question in the questions tab",
                "question_placeholder": "Write your question here",
                "send_anonymous": "Send anonymously",
                "send": "Send",
                "answers": "Answers",
                "questions": "Questions",
                "no_answers_yet": "No answers yet",
                "no_answers_yet_description": "When {{first_name}} answers a question, the answer will appear here.",
                "no_answers_yet_description_owner": "Send a link to your profile to friends so they can ask you questions.",
                "no_questions_yet": "No questions yet",
                "no_questions_yet_description": "You haven't asked this user any questions yet.",
                "no_questions_yet_description_owner": "No questions yet. Share a link to your profile so your friends can ask you questions.",
                "ask_question_action": "Ask a question",
                "send_link_action": "Send link",
                "share_link_action": "Share link",
                "answer": "Answer",
                "answer_placeholder": "Write your answer here",
                "delete": "Delete",
                "cancel": "Cancel",
                "go_to_my_profile": "Go to my profile",
                "open_profile": "Open profile",
                "cancel_answer": "Cancel answer",
                "delete_question": "Delete question",
                "question_sent": "Question sent",
                "question_send_error": "Question send error",
                "answer_sent": "Answer sent",
                "answer_send_error": "Answer send error",
                "question_deleted": "Question deleted",
                "question_delete_error": "Question delete error",
                "answer_cancelled": "Answer cancelled",
                "answer_cancel_error": "Answer cancel error",
                "delete_question_confirmation": "Are you sure you want to delete this question?",
                "withdraw_answer_confirmation": "Are you sure you want to withdraw this answer?",
                "withdraw_answer_action": "Withdraw",
                "cancel_title": "Cancel answer",
                "delete_title": "Delete question",
                "profile_loading_error": "Profile loading error 😔",
                "should_try_reload": "You should try to reload the app",
                "repeat": "Repeat",
                "share_profile_owner_text": "With the link you can ask me an anonymous question!",
                "share_profile_text": "With the link you can ask an anonymous question!\n{{first_name}} {{last_name}}",
                "anonymous": "Anonymous",
                "questions_from_you": "Here are the questions you asked",
                "update_profile_photo_title": "Update profile photo",
                "save_photo": "Save photo",
                "profile_photo_updated": "Profile photo updated",
                "profile_photo_update_error": "Profile photo update error",
                "select_file": "Select file",
                "unknown_error": "Unknown error",
                "share_answer": "Share answer",
                "sent": "Sent",
                "answer_from_bot": "Answer from @askerixbot",
                "subscribe": "Subscribe",
                "unsubscribe": "Unsubscribe",
                "subscribed": "You are subscribed to notifications about new answers from the user",
                "unsubscribed": "You are unsubscribed from notifications about new answers from the user",
                "still_not_answered": "{{first_name}} is still thinking about what to answer",
                "asked_questions": "Questions you asked",
                "function_not_supported": "The feature is not supported on your device yet",
                "sent_by_bot": "Sent in a message from the bot",
            }
        },
        uk: {
            translation: {
                "ask_me_anything": "Запитай мене що завгодно",
                "ask_me_anything_owner": "Запитайте себе питання",
                "ask_me_anything_footer": "Коли {{first_name}} відповість на ваше питання, воно з'явиться у списку відповідей.",
                "ask_me_anything_footer_owner": "Ви знайдете своє пита��ня на вкладці питань",
                "question_placeholder": "Напишіть ваше питання тут",
                "send_anonymous": "Надіслати анонімно",
                "send": "Надіслати",
                "answers": "Відповіді",
                "questions": "Питання",
                "no_answers_yet": "Поки що немає відповідей",
                "no_answers_yet_description": "Коли {{first_name}} відповість на питання, відповідь з'явиться тут.",
                "no_answers_yet_description_owner": "Надішліть посилання на свій профіль друзям, щоб вони могли задати вам питання.",
                "no_questions_yet": "Поки що немає питань",
                "no_questions_yet_description": "Ви ще не задавали цьому користувачеві питань.",
                "no_questions_yet_description_owner": "Поки що немає питань. Поділіться посиланням на свій профіль, щоб ваші друзі могли задати вам питання.",
                "ask_question_action": "Задати питання",
                "send_link_action": "Надіслати посилання",
                "share_link_action": "Поділитися посиланням",
                "answer": "Відповісти",
                "answer_placeholder": "Напишіть вашу відповідь тут",
                "delete": "Видалити",
                "cancel": "Скасувати",
                "go_to_my_profile": "Перейти до мого профілю",
                "open_profile": "Відкрити профіль",
                "cancel_answer": "Скасувати відповідь",
                "delete_question": "Видалити питання",
                "question_sent": "Питання відправлено",
                "question_send_error": "Помилка відправки питання",
                "answer_sent": "Відповідь відправлена",
                "answer_send_error": "Помилка відправки відповіді",
                "question_deleted": "Питання видалено",
                "question_delete_error": "Помилка видалення питання",
                "answer_cancelled": "Відповідь скасована",
                "answer_cancel_error": "Помилка скасування відповіді",
                "delete_question_confirmation": "Ви впевнені, що хочете видалити це питання?",
                "withdraw_answer_confirmation": "Ви впевнені, що хочете відкликати цю відповідь?",
                "withdraw_answer_action": "Відкликати",
                "cancel_title": "Скасувати відповідь",
                "delete_title": "Видалення питання",
                "profile_loading_error": "Помилка завантаження профілю 😔",
                "should_try_reload": "Спробуйте перезавантажити додаток",
                "repeat": "Повторити",
                "share_profile_owner_text": "З посиланням ви можете задати мені анонімне питання!",
                "share_profile_text": "З посиланням ви можете задати анонімне питання!\n{{first_name}} {{last_name}}",
                "anonymous": "Анонімно",
                "questions_from_you": "Тут відображаються питання, які ви задали",
                "update_profile_photo_title": "Оновити фото профілю",
                "save_photo": "Зберегти фото",
                "profile_photo_updated": "Фото профілю оновлено",
                "profile_photo_update_error": "Помилка оновлення фото профілю",
                "select_file": "Вибрати файл",
                "unknown_error": "Невідома помилка",
                "share_answer": "Поділитися відповіддю",
                "sent": "Відправлено",
                "answer_from_bot": "Відповідь від @askerixbot",
                "subscribe": "Підписатися",
                "unsubscribe": "Відписатися",
                "subscribed": "Ви підписані на сповіщення про нові відповіді користувача",
                "unsubscribed": "Ви відписані від сповіщень про нові відповіді користувача",
                "still_not_answered": "{{first_name}} ще думає, що відповісти",
                "asked_questions": "Питання, які ви задали",
                "function_not_supported": "Функція ще не підтримується на вашому пристрої",
                "sent_by_bot": "Відправлено в повідомленні від бота",
            }
        },
        "id": {
            translation: {
                "ask_me_anything": "Tanyakan apa saja",
                "ask_me_anything_owner": "Tanyakan diri Anda sendiri",
                "ask_me_anything_footer": "Ketika {{first_name}} menjawab pertanyaan Anda, itu akan muncul di daftar jawaban.",
                "ask_me_anything_footer_owner": "Anda akan menemukan pertanyaan Anda di tab pertanyaan",
                "question_placeholder": "Tulis pertanyaan Anda di sini",
                "send_anonymous": "Kirim secara anonim",
                "send": "Kirim",
                "answers": "Jawaban",
                "questions": "Pertanyaan",
                "no_answers_yet": "Belum ada jawaban",
                "no_answers_yet_description": "Ketika {{first_name}} menjawab pertanyaan, jawabannya akan muncul di sini.",
                "no_answers_yet_description_owner": "Kirimkan tautan ke profil Anda ke teman sehingga mereka dapat bertanya kepada Anda.",
                "no_questions_yet": "Belum ada pertanyaan",
                "no_questions_yet_description": "Anda belum bertanya kepada pengguna ini.",
                "no_questions_yet_description_owner": "Belum ada pertanyaan. Bagikan tautan ke profil Anda sehingga teman Anda dapat bertanya kepada Anda.",
                "ask_question_action": "Ajukan pertanyaan",
                "send_link_action": "Kirim tautan",
                "share_link_action": "Bagikan tautan",
                "answer": "Jawab",
                "answer_placeholder": "Tulis jawaban Anda di sini",
                "delete": "Hapus",
                "cancel": "Batal",
                "go_to_my_profile": "Buka profil saya",
                "open_profile": "Buka profil",
                "cancel_answer": "Batal jawaban",
                "delete_question": "Hapus pertanyaan",
                "question_sent": "Pertanyaan terkirim",
                "question_send_error": "Kesalahan pengiriman pertanyaan",
                "answer_sent": "Jawaban terkirim",
                "answer_send_error": "Kesalahan pengiriman jawaban",
                "question_deleted": "Pertanyaan dihapus",
                "question_delete_error": "Kesalahan menghapus pertanyaan",
                "answer_cancelled": "Jawaban dibatalkan",
                "answer_cancel_error": "Kesalahan pembatalan jawaban",
                "delete_question_confirmation": "Apakah Anda yakin ingin menghapus pertanyaan ini?",
                "withdraw_answer_confirmation": "Apakah Anda yakin ingin menarik jawaban ini?",
                "withdraw_answer_action": "Tarik",
                "cancel_title": "Batal jawaban",
                "delete_title": "Hapus pertanyaan",
                "profile_loading_error": "Kesalahan memuat profil 😔",
                "should_try_reload": "Anda harus mencoba untuk me-reload aplikasi",
                "repeat": "Ulang",
                "share_profile_owner_text": "Dengan tautan ini, Anda dapat bertanya kepada saya secara anonim!",
                "share_profile_text": "Dengan tautan ini, Anda dapat bertanya secara anonim!\n{{first_name}} {{last_name}}",
                "anonymous": "Anonim",
                "questions_from_you": "Berikut adalah pertanyaan yang Anda ajukan",
                "update_profile_photo_title": "Perbarui foto profil",
                "save_photo": "Simpan foto",
                "profile_photo_updated": "Foto profil diperbarui",
                "profile_photo_update_error": "Kesalahan pembaruan foto profil",
                "select_file": "Pilih file",
                "unknown_error": "Kesalahan tidak diketahui",
                "share_answer": "Bagikan jawaban",
                "sent": "Terkirim",
                "answer_from_bot": "Jawaban dari @askerixbot",
                "subscribe": "Berlangganan",
                "unsubscribe": "Berhenti berlangganan",
                "subscribed": "Anda berlangganan untuk pemberitahuan tentang jawaban baru dari pengguna",
                "unsubscribed": "Anda berhenti berlangganan dari pemberitahuan tentang jawaban baru dari pengguna",
                "still_not_answered": "{{first_name}} masih berpikir apa yang akan dijawab",
                "asked_questions": "Pertanyaan yang Anda ajukan",
                "function_not_supported": "Fitur belum didukung di perangkat Anda",
                "sent_by_bot": "Dikirim dalam pesan dari bot",
            },
        },
        pt: {
            translation: {
                "ask_me_anything": "Pergunte-me qualquer coisa",
                "ask_me_anything_owner": "Faça uma pergunta a si mesmo",
                "ask_me_anything_footer": "Quando {{first_name}} responder à sua pergunta, ela aparecerá na lista de respostas.",
                "ask_me_anything_footer_owner": "Você encontrará sua pergunta na aba de perguntas",
                "question_placeholder": "Escreva sua pergunta aqui",
                "send_anonymous": "Enviar anonimamente",
                "send": "Enviar",
                "answers": "Respostas",
                "questions": "Perguntas",
                "no_answers_yet": "Ainda sem respostas",
                "no_answers_yet_description": "Quando {{first_name}} responder a uma pergunta, a resposta aparecerá aqui.",
                "no_answers_yet_description_owner": "Envie um link para o seu perfil para os amigos para que eles possam fazer perguntas a você.",
                "no_questions_yet": "Ainda sem perguntas",
                "no_questions_yet_description": "Você ainda não fez perguntas a este usuário.",
                "no_questions_yet_description_owner": "Ainda sem perguntas. Compartilhe um link para o seu perfil para que seus amigos possam fazer perguntas a você.",
                "ask_question_action": "Fazer uma pergunta",
                "send_link_action": "Enviar link",
                "share_link_action": "Compartilhar link",
                "answer": "Responder",
                "answer_placeholder": "Escreva sua resposta aqui",
                "delete": "Excluir",
                "cancel": "Cancelar",
                "go_to_my_profile": "Ir para o meu perfil",
                "open_profile": "Abrir perfil",
                "cancel_answer": "Cancelar resposta",
                "delete_question": "Excluir pergunta",
                "question_sent": "Pergunta enviada",
                "question_send_error": "Erro ao enviar a pergunta",
                "answer_sent": "Resposta enviada",
                "answer_send_error": "Erro ao enviar a resposta",
                "question_deleted": "Pergunta excluída",
                "question_delete_error": "Erro ao excluir a pergunta",
                "answer_cancelled": "Resposta cancelada",
                "answer_cancel_error": "Erro ao cancelar a resposta",
                "delete_question_confirmation": "Tem certeza de que deseja excluir esta pergunta?",
                "withdraw_answer_confirmation": "Tem certeza de que deseja retirar esta resposta?",
                "withdraw_answer_action": "Retirar",
                "cancel_title": "Cancelar resposta",
                "delete_title": "Excluir pergunta",
                "profile_loading_error": "Erro ao carregar o perfil 😔",
                "should_try_reload": "Você deve tentar recarregar o aplicativo",
                "repeat": "Repetir",
                "share_profile_owner_text": "Com o link, você pode me fazer uma pergunta anônima!",
                "share_profile_text": "Com o link, você pode fazer uma pergunta anônima!\n{{first_name}} {{last_name}}",
                "anonymous": "Anônimo",
                "questions_from_you": "Aqui estão as perguntas que você fez",
                "update_profile_photo_title": "Atualizar foto de perfil",
                "save_photo": "Salvar foto",
                "profile_photo_updated": "Foto de perfil atualizada",
                "profile_photo_update_error": "Erro ao atualizar a foto de perfil",
                "select_file": "Selecione o arquivo",
                "unknown_error": "Erro desconhecido",
                "share_answer": "Compartilhar resposta",
                "sent": "Enviado",
                "answer_from_bot": "Resposta de @askerixbot",
                "subscribe": "Inscrever-se",
                "unsubscribe": "Cancelar inscrição",
                "subscribed": "Você está inscrito para notificações sobre novas respostas do usuário",
                "unsubscribed": "Você está desinscrito das notificações sobre novas respostas do usuário",
                "still_not_answered": "{{first_name}} ainda está pensando no que responder",
                "asked_questions": "Perguntas que você fez",
                "function_not_supported": "O recurso ainda não é suportado no seu dispositivo",
                "sent_by_bot": "Enviado em uma mensagem do bot",
            }
        },
        es: {
            translation: {
                "ask_me_anything": "Pregúntame lo que sea",
                "ask_me_anything_owner": "Hazte una pregunta",
                "ask_me_anything_footer": "Cuando {{first_name}} responda a tu pregunta, aparecerá en la lista de respuestas.",
                "ask_me_anything_footer_owner": "Encontrarás tu pregunta en la pestaña de preguntas",
                "question_placeholder": "Escribe tu pregunta aquí",
                "send_anonymous": "Enviar de forma anónima",
                "send": "Enviar",
                "answers": "Respuestas",
                "questions": "Preguntas",
                "no_answers_yet": "Aún no hay respuestas",
                "no_answers_yet_description": "Cuando {{first_name}} responda a una pregunta, la respuesta aparecerá aquí.",
                "no_answers_yet_description_owner": "Envía un enlace a tu perfil a tus amigos para que puedan hacerte preguntas.",
                "no_questions_yet": "Aún no hay preguntas",
                "no_questions_yet_description": "Todavía no le has hecho preguntas a este usuario.",
                "no_questions_yet_description_owner": "Aún no hay preguntas. Comparte un enlace a tu perfil para que tus amigos puedan hacerte preguntas.",
                "ask_question_action": "Hacer una pregunta",
                "send_link_action": "Enviar enlace",
                "share_link_action": "Compartir enlace",
                "answer": "Responder",
                "answer_placeholder": "Escribe tu respuesta aquí",
                "delete": "Eliminar",
                "cancel": "Cancelar",
                "go_to_my_profile": "Ir a mi perfil",
                "open_profile": "Abrir perfil",
                "cancel_answer": "Cancelar respuesta",
                "delete_question": "Eliminar pregunta",
                "question_sent": "Pregunta enviada",
                "question_send_error": "Error al enviar la pregunta",
                "answer_sent": "Respuesta enviada",
                "answer_send_error": "Error al enviar la respuesta",
                "question_deleted": "Pregunta eliminada",
                "question_delete_error": "Error al eliminar la pregunta",
                "answer_cancelled": "Respuesta cancelada",
                "answer_cancel_error": "Error al cancelar la respuesta",
                "delete_question_confirmation": "¿Estás seguro de que quieres eliminar esta pregunta?",
                "withdraw_answer_confirmation": "¿Estás seguro de que quieres retirar esta respuesta?",
                "withdraw_answer_action": "Retirar",
                "cancel_title": "Cancelar respuesta",
                "delete_title": "Eliminar pregunta",
                "profile_loading_error": "Error al cargar el perfil 😔",
                "should_try_reload": "Deberías intentar recargar la aplicación",
                "repeat": "Repetir",
                "share_profile_owner_text": "¡Con el enlace puedes hacerme una pregunta anónima!",
                "share_profile_text": "¡Con el enlace puedes hacer una pregunta anónima!\n{{first_name}} {{last_name}}",
                "anonymous": "Anónimo",
                "questions_from_you": "Aquí están las preguntas que hiciste",
                "update_profile_photo_title": "Actualizar foto de perfil",
                "save_photo": "Guardar foto",
                "profile_photo_updated": "Foto de perfil actualizada",
                "profile_photo_update_error": "Error al actualizar la foto de perfil",
                "select_file": "Seleccionar archivo",
                "unknown_error": "Error desconocido",
                "share_answer": "Compartir respuesta",
                "sent": "Enviado",
                "answer_from_bot": "Respuesta de @askerixbot",
                "subscribe": "Suscribirse",
                "unsubscribe": "Cancelar suscripción",
                "subscribed": "Estás suscrito a notificaciones sobre nuevas respuestas del usuario",
                "unsubscribed": "Estás desuscrito de notificaciones sobre nuevas respuestas del usuario",
                "still_not_answered": "{{first_name}} todavía está pensando en qué responder",
                "asked_questions": "Preguntas que hiciste",
                "function_not_supported": "La función aún no es compatible con tu dispositivo",
                "sent_by_bot": "Enviado en un mensaje del bot",
            }
        },
        fr: {
            translation: {
                "ask_me_anything": "Posez-moi n'importe quelle question",
                "ask_me_anything_owner": "Posez-vous une question",
                "ask_me_anything_footer": "Lorsque {{first_name}} répondra à votre question, elle apparaîtra dans la liste des réponses.",
                "ask_me_anything_footer_owner": "Vous trouverez votre question dans l'onglet des questions",
                "question_placeholder": "Écrivez votre question ici",
                "send_anonymous": "Envoyer anonymement",
                "send": "Envoyer",
                "answers": "Réponses",
                "questions": "Questions",
                "no_answers_yet": "Pas encore de réponses",
                "no_answers_yet_description": "Lorsque {{first_name}} répondra à une question, la réponse apparaîtra ici.",
                "no_answers_yet_description_owner": "Envoyez un lien vers votre profil à vos amis pour qu'ils puissent vous poser des questions.",
                "no_questions_yet": "Pas encore de questions",
                "no_questions_yet_description": "Vous n'avez pas encore posé de questions à cet utilisateur.",
                "no_questions_yet_description_owner": "Pas encore de questions. Partagez un lien vers votre profil pour que vos amis puissent vous poser des questions.",
                "ask_question_action": "Poser une question",
                "send_link_action": "Envoyer le lien",
                "share_link_action": "Partager le lien",
                "answer": "Répondre",
                "answer_placeholder": "Écrivez votre réponse ici",
                "delete": "Supprimer",
                "cancel": "Annuler",
                "go_to_my_profile": "Aller à mon profil",
                "open_profile": "Ouvrir le profil",
                "cancel_answer": "Annuler la réponse",
                "delete_question": "Supprimer la question",
                "question_sent": "Question envoyée",
                "question_send_error": "Erreur d'envoi de la question",
                "answer_sent": "Réponse envoyée",
                "answer_send_error": "Erreur d'envoi de la réponse",
                "question_deleted": "Question supprimée",
                "question_delete_error": "Erreur de suppression de la question",
                "answer_cancelled": "Réponse annulée",
                "answer_cancel_error": "Erreur d'annulation de la réponse",
                "delete_question_confirmation": "Êtes-vous sûr de vouloir supprimer cette question ?",
                "withdraw_answer_confirmation": "Êtes-vous sûr de vouloir retirer cette réponse ?",
                "withdraw_answer_action": "Retirer",
                "cancel_title": "Annuler la réponse",
                "delete_title": "Supprimer la question",
                "profile_loading_error": "Erreur de chargement du profil 😔",
                "should_try_reload": "Vous devriez essayer de recharger l'application",
                "repeat": "Répéter",
                "share_profile_owner_text": "Avec le lien, vous pouvez me poser une question anonyme !",
                "share_profile_text": "Avec le lien, vous pouvez poser une question anonyme !\n{{first_name}} {{last_name}}",
                "anonymous": "Anonyme",
                "questions_from_you": "Voici les questions que vous avez posées",
                "update_profile_photo_title": "Mettre à jour la photo de profil",
                "save_photo": "Enregistrer la photo",
                "profile_photo_updated": "Photo de profil mise à jour",
                "profile_photo_update_error": "Erreur de mise à jour de la photo de profil",
                "select_file": "Sélectionner un fichier",
                "unknown_error": "Erreur inconnue",
                "share_answer": "Partager la réponse",
                "sent": "Envoyé",
                "answer_from_bot": "Réponse de @askerixbot",
                "subscribe": "S'abonner",
                "unsubscribe": "Se désabonner",
                "subscribed": "Vous êtes abonné aux notifications sur les nouvelles réponses de l'utilisateur",
                "unsubscribed": "Vous êtes désabonné des notifications sur les nouvelles réponses de l'utilisateur",
                "still_not_answered": "{{first_name}} réfléchit encore à ce qu'il va répondre",
                "asked_questions": "Questions que vous avez posées",
                "function_not_supported": "La fonctionnalité n'est pas encore prise en charge sur votre appareil",
                "sent_by_bot": "Envoyé dans un message du bot",
            }
        },
        it: {
            translation: {
                "ask_me_anything": "Chiedimi qualsiasi cosa",
                "ask_me_anything_owner": "Fatti una domanda",
                "ask_me_anything_footer": "Quando {{first_name}} risponderà alla tua domanda, apparirà nell'elenco delle risposte.",
                "ask_me_anything_footer_owner": "Troverai la tua domanda nella scheda delle domande",
                "question_placeholder": "Scrivi la tua domanda qui",
                "send_anonymous": "Invia in modo anonimo",
                "send": "Invia",
                "answers": "Risposte",
                "questions": "Domande",
                "no_answers_yet": "Ancora nessuna risposta",
                "no_answers_yet_description": "Quando {{first_name}} risponderà a una domanda, la risposta apparirà qui.",
                "no_answers_yet_description_owner": "Invia un link al tuo profilo agli amici in modo che possano farti domande.",
                "no_questions_yet": "Ancora nessuna domanda",
                "no_questions_yet_description": "Non hai ancora fatto domande a questo utente.",
                "no_questions_yet_description_owner": "Ancora nessuna domanda. Condividi un link al tuo profilo in modo che i tuoi amici possano farti domande.",
                "ask_question_action": "Fai una domanda",
                "send_link_action": "Invia link",
                "share_link_action": "Condividi link",
                "answer": "Rispondi",
                "answer_placeholder": "Scrivi la tua risposta qui",
                "delete": "Elimina",
                "cancel": "Annulla",
                "go_to_my_profile": "Vai al mio profilo",
                "open_profile": "Apri profilo",
                "cancel_answer": "Annulla risposta",
                "delete_question": "Elimina domanda",
                "question_sent": "Domanda inviata",
                "question_send_error": "Errore di invio della domanda",
                "answer_sent": "Risposta inviata",
                "answer_send_error": "Errore di invio della risposta",
                "question_deleted": "Domanda eliminata",
                "question_delete_error": "Errore di eliminazione della domanda",
                "answer_cancelled": "Risposta annullata",
                "answer_cancel_error": "Errore di annullamento della risposta",
                "delete_question_confirmation": "Sei sicuro di voler eliminare questa domanda?",
                "withdraw_answer_confirmation": "Sei sicuro di voler ritirare questa risposta?",
                "withdraw_answer_action": "Ritirare",
                "cancel_title": "Annulla risposta",
                "delete_title": "Elimina domanda",
                "profile_loading_error": "Errore di caricamento del profilo 😔",
                "should_try_reload": "Dovresti provare a ricaricare l'app",
                "repeat": "Ripeti",
                "share_profile_owner_text": "Con il link puoi farmi una domanda anonima!",
                "share_profile_text": "Con il link puoi fare una domanda anonima!\n{{first_name}} {{last_name}}",
                "anonymous": "Anonimo",
                "questions_from_you": "Ecco le domande che hai fatto",
                "update_profile_photo_title": "Aggiorna foto del profilo",
                "save_photo": "Salva foto",
                "profile_photo_updated": "Foto del profilo aggiornata",
                "profile_photo_update_error": "Errore di aggiornamento della foto del profilo",
                "select_file": "Seleziona file",
                "unknown_error": "Errore sconosciuto",
                "share_answer": "Condividi risposta",
                "sent": "Inviato",
                "answer_from_bot": "Risposta da @askerixbot",
                "subscribe": "Iscriviti",
                "unsubscribe": "Annulla iscrizione",
                "subscribed": "Sei iscritto alle notifiche sulle nuove risposte dell'utente",
                "unsubscribed": "Sei disiscritto dalle notifiche sulle nuove risposte dell'utente",
                "still_not_answered": "{{first_name}} sta ancora pensando a cosa rispondere",
                "asked_questions": "Domande che hai fatto",
                "function_not_supported": "La funzionalità non è ancora supportata sul tuo dispositivo",
                "sent_by_bot": "Inviato in un messaggio dal bot",
            }
        },
        de: {
            translation: {
                "ask_me_anything": "Frag mich alles",
                "ask_me_anything_owner": "Stellen Sie sich eine Frage",
                "ask_me_anything_footer": "Wenn {{first_name}} Ihre Frage beantwortet, wird sie in der Liste der Antworten angezeigt.",
                "ask_me_anything_footer_owner": "Sie finden Ihre Frage im Fragen-Tab",
                "question_placeholder": "Schreiben Sie Ihre Frage hier",
                "send_anonymous": "Anonym senden",
                "send": "Senden",
                "answers": "Antworten",
                "questions": "Fragen",
                "no_answers_yet": "Noch keine Antworten",
                "no_answers_yet_description": "Wenn {{first_name}} eine Frage beantwortet, wird die Antwort hier angezeigt.",
                "no_answers_yet_description_owner": "Senden Sie einen Link zu Ihrem Profil an Freunde, damit sie Ihnen Fragen stellen können.",
                "no_questions_yet": "Noch keine Fragen",
                "no_questions_yet_description": "Sie haben diesem Benutzer noch keine Fragen gestellt.",
                "no_questions_yet_description_owner": "Noch keine Fragen. Teilen Sie einen Link zu Ihrem Profil, damit Ihre Freunde Ihnen Fragen stellen können.",
                "ask_question_action": "Frage stellen",
                "send_link_action": "Link senden",
                "share_link_action": "Link teilen",
                "answer": "Antworten",
                "answer_placeholder": "Schreiben Sie Ihre Antwort hier",
                "delete": "Löschen",
                "cancel": "Abbrechen",
                "go_to_my_profile": "Zu meinem Profil gehen",
                "open_profile": "Profil öffnen",
                "cancel_answer": "Antwort abbrechen",
                "delete_question": "Frage löschen",
                "question_sent": "Frage gesendet",
                "question_send_error": "Fehler beim Senden der Frage",
                "answer_sent": "Antwort gesendet",
                "answer_send_error": "Fehler beim Senden der Antwort",
                "question_deleted": "Frage gelöscht",
                "question_delete_error": "Fehler beim Löschen der Frage",
                "answer_cancelled": "Antwort abgebrochen",
                "answer_cancel_error": "Fehler beim Abbrechen der Antwort",
                "delete_question_confirmation": "Möchten Sie diese Frage wirklich löschen?",
                "withdraw_answer_confirmation": "Möchten Sie diese Antwort wirklich zurückziehen?",
                "withdraw_answer_action": "Zurückziehen",
                "cancel_title": "Antwort abbrechen",
                "delete_title": "Frage löschen",
                "profile_loading_error": "Fehler beim Laden des Profils 😔",
                "should_try_reload": "Sie sollten versuchen, die App neu zu laden",
                "repeat": "Wiederholen",
                "share_profile_owner_text": "Mit dem Link können Sie mir eine anonyme Frage stellen!",
                "share_profile_text": "Mit dem Link können Sie eine anonyme Frage stellen!\n{{first_name}} {{last_name}}",
                "anonymous": "Anonym",
                "questions_from_you": "Hier sind die Fragen, die Sie gestellt haben",
                "update_profile_photo_title": "Profilfoto aktualisieren",
                "save_photo": "Foto speichern",
                "profile_photo_updated": "Profilfoto aktualisiert",
                "profile_photo_update_error": "Fehler beim Aktualisieren des Profilfotos",
                "select_file": "Datei auswählen",
                "unknown_error": "Unbekannter Fehler",
                "share_answer": "Antwort teilen",
                "sent": "Gesendet",
                "answer_from_bot": "Antwort von @askerixbot",
                "subscribe": "Abonnieren",
                "unsubscribe": "Abbestellen",
                "subscribed": "Sie sind für Benachrichtigungen über neue Antworten des Benutzers angemeldet",
                "unsubscribed": "Sie sind von Benachrichtigungen über neue Antworten des Benutzers abgemeldet",
                "still_not_answered": "{{first_name}} überlegt noch, was er antworten soll",
                "asked_questions": "Gestellte Fragen",
                "function_not_supported": "Die Funktion wird auf Ihrem Gerät noch nicht unterstützt",
                "sent_by_bot": "Gesendet in einer Nachricht vom Bot",
            }
        },
        tr: {
            translation: {
                "ask_me_anything": "Bana her şeyi sor",
                "ask_me_anything_owner": "Kendinize bir soru sorun",
                "ask_me_anything_footer": "{{first_name}} sorunuzu yanıtladığında, yanıt yanıtlar listesinde görünecektir.",
                "ask_me_anything_footer_owner": "Sorular sekmesinde sorunuzu bulacaksınız",
                "question_placeholder": "Sorunuzu buraya yazın",
                "send_anonymous": "Anonim gönder",
                "send": "Gönder",
                "answers": "Yanıtlar",
                "questions": "Sorular",
                "no_answers_yet": "Henüz yanıt yok",
                "no_answers_yet_description": "{{first_name}} bir soruyu yanıtladığında, yanıt burada görünecektir.",
                "no_answers_yet_description_owner": "Arkadaşlarınıza size soru sorabilmeleri için profilinize bir bağlantı gönderin.",
                "no_questions_yet": "Henüz soru yok",
                "no_questions_yet_description": "Bu kullanıcıya henüz soru sormadınız.",
                "no_questions_yet_description_owner": "Henüz soru yok. Arkadaşlarınız size soru sormak için profilinize bir bağlantı paylaşın.",
                "ask_question_action": "Soru sor",
                "send_link_action": "Bağlantı gönder",
                "share_link_action": "Bağlantıyı paylaş",
                "answer": "Yanıtla",
                "answer_placeholder": "Yanıtınızı buraya yazın",
                "delete": "Sil",
                "cancel": "İptal",
                "go_to_my_profile": "Profilime git",
                "open_profile": "Profili aç",
                "cancel_answer": "Yanıtı iptal et",
                "delete_question": "Soruyu sil",
                "question_sent": "Soru gönderildi",
                "question_send_error": "Soru gönderme hatası",
                "answer_sent": "Yanıt gönderildi",
                "answer_send_error": "Yanıt gönderme hatası",
                "question_deleted": "Soru silindi",
                "question_delete_error": "Soru silme hatası",
                "answer_cancelled": "Yanıt iptal edildi",
                "answer_cancel_error": "Yanıt iptal hatası",
                "delete_question_confirmation": "Bu soruyu silmek istediğinizden emin misiniz?",
                "withdraw_answer_confirmation": "Bu yanıtı geri çekmek istediğinizden emin misiniz?",
                "withdraw_answer_action": "Geri çek",
                "cancel_title": "Yanıtı iptal et",
                "delete_title": "Soruyu sil",
                "profile_loading_error": "Profil yükleme hatası 😔",
                "should_try_reload": "Uygulamayı yeniden yüklemeyi deneyin",
                "repeat": "Tekrar",
                "share_profile_owner_text": "Bu bağlantı ile bana anonim bir soru sorabilirsiniz!",
                "share_profile_text": "Bu bağlantı ile anonim bir soru sorabilirsiniz!\n{{first_name}} {{last_name}}",
                "anonymous": "Anonim",
                "questions_from_you": "Sorduğunuz sorular burada",
                "update_profile_photo_title": "Profil fotoğrafını güncelle",
                "save_photo": "Fotoğrafı kaydet",
                "profile_photo_updated": "Profil fotoğrafı güncellendi",
                "profile_photo_update_error": "Profil fotoğrafı güncelleme hatası",
                "select_file": "Dosya seç",
                "unknown_error": "Bilinmeyen hata",
                "share_answer": "Yanıtı paylaş",
                "sent": "Gönderildi",
                "answer_from_bot": "@askerixbot tarafından yanıt",
                "subscribe": "Abone ol",
                "unsubscribe": "Abonelikten çık",
                "subscribed": "Yeni kullanıcı yanıtlarına ilişkin bildirimler için abonesiniz",
                "unsubscribed": "Yeni kullanıcı yanıtlarına ilişkin bildirimlerden aboneliğiniz kaldırıldı",
                "still_not_answered": "{{first_name}} hala ne yanıt vereceğine karar veriyor",
                "asked_questions": "Sorduğunuz sorular",
                "function_not_supported": "Özellik henüz cihazınızda desteklenmiyor",
                "sent_by_bot": "Bot mesajında gönderildi",
            }
        },
        zh: {
            translation: {
                "ask_me_anything": "问我任何问题",
                "ask_me_anything_owner": "问自己一个问题",
                "ask_me_anything_footer": "当{{first_name}}回答您的问题时，它将出现在答案列表中。",
                "ask_me_anything_footer_owner": "您将在问题选项卡中找到您的问题",
                "question_placeholder": "在这里写下您的问题",
                "send_anonymous": "匿名发送",
                "send": "发送",
                "answers": "答案",
                "questions": "问题",
                "no_answers_yet": "还没有答案",
                "no_answers_yet_description": "当{{first_name}}回答问题时，答案将出现在这里。",
                "no_answers_yet_description_owner": "向朋友发送您的个人资料链接，以便他们可以向您提问。",
                "no_questions_yet": "还没有问题",
                "no_questions_yet_description": "您还没有向此用户提问。",
                "no_questions_yet_description_owner": "还没有问题。分享您的个人资料链接，以便您的朋友可以向您提问。",
                "ask_question_action": "提问",
                "send_link_action": "发送链接",
                "share_link_action": "分享链接",
                "answer": "回答",
                "answer_placeholder": "在这里写下您的答案",
                "delete": "删除",
                "cancel": "取消",
                "go_to_my_profile": "转到我的个人资料",
                "open_profile": "打开个人资料",
                "cancel_answer": "取消答案",
                "delete_question": "删除问题",
                "question_sent": "问题已发送",
                "question_send_error": "问题发送错误",
                "answer_sent": "答案已发送",
                "answer_send_error": "答案发送错误",
                "question_deleted": "问题已删除",
                "question_delete_error": "问题删除错误",
                "answer_cancelled": "答案已取消",
                "answer_cancel_error": "答案取消错误",
                "delete_question_confirmation": "您确定要删除此问题吗？",
                "withdraw_answer_confirmation": "您确定要撤回此答案吗？",
                "withdraw_answer_action": "撤回",
                "cancel_title": "取消答案",
                "delete_title": "删除问题",
                "profile_loading_error": "个人资料加载错误 😔",
                "should_try_reload": "您应该尝试重新加载应用",
                "repeat": "重复",
                "share_profile_owner_text": "使用此链接，您可以匿名向我提问！",
                "share_profile_text": "使用此链接，您可以匿名提问！\n{{first_name}} {{last_name}}",
                "anonymous": "匿名",
                "questions_from_you": "这里是您提出的问题",
                "update_profile_photo_title": "更新个人资料照片",
                "save_photo": "保存照片",
                "profile_photo_updated": "个人资料照片已更新",
                "profile_photo_update_error": "个人资料照片更新错误",
                "select_file": "选择文件",
                "unknown_error": "未知错误",
                "share_answer": "分享答案",
                "sent": "已发送",
                "answer_from_bot": "@askerixbot的答案",
                "subscribe": "订阅",
                "unsubscribe": "取消订阅",
                "subscribed": "您已订阅用户新答案的通知",
                "unsubscribed": "您已取消订阅用户新答案的通知",
                "still_not_answered": "{{first_name}}仍在考虑如何回答",
                "asked_questions": "您提出的问题",
                "function_not_supported": "您的设备尚不支持此功能",
                "sent_by_bot": "在机器人消息中发送",
            }
        },
        uz: {
            translation: {
                "ask_me_anything": "Menga savol bering",
                "ask_me_anything_owner": "O'zingizga savol bering",
                "ask_me_anything_footer": "Agar {{first_name}} savolingizga javob beradigan bo'lsa, u javoblar ro'yxatida paydo bo'ladi.",
                "ask_me_anything_footer_owner": "Siz savolingizni savollar bo'limida topasiz",
                "question_placeholder": "Savolingizni shu yerga yozing",
                "send_anonymous": "Anonim yuborish",
                "send": "Yuborish",
                "answers": "Javoblar",
                "questions": "Savollar",
                "no_answers_yet": "Hali javoblar yo'q",
                "no_answers_yet_description": "Agar {{first_name}} savolga javob beringan bo'lsa, javob bu erda paydo bo'ladi.",
                "no_answers_yet_description_owner": "Do'stlarga o'zingizga savol berishlari uchun profil havolani yuboring.",
                "no_questions_yet": "Hali savollar yo'q",
                "no_questions_yet_description": "Siz bu foydalanuvchiga hali savol bermadingiz.",
                "no_questions_yet_description_owner": "Hali savollar yo'q. Do'stlarga o'zingizga savol berishlari uchun profil havolani ulashing.",
                "ask_question_action": "Savol berish",
                "send_link_action": "Havolani yuborish",
                "share_link_action": "Havolani ulashish",
                "answer": "Javob bering",
                "answer_placeholder": "Javobingizni shu yerga yozing",
                "delete": "O'chirish",
                "cancel": "Bekor qilish",
                "go_to_my_profile": "Mening profilimga o'tish",
                "open_profile": "Profilni ochish",
                "cancel_answer": "Javobni bekor qilish",
                "delete_question": "Savolni o'chirish",
                "question_sent": "Savol yuborildi",
                "question_send_error": "Savol yuborishda xatolik",
                "answer_sent": "Javob yuborildi",
                "answer_send_error": "Javob yuborishda xatolik",
                "question_deleted": "Savol o'chirildi",
                "question_delete_error": "Savol o'chirishda xatolik",
                "answer_cancelled": "Javob bekor qilindi",
                "answer_cancel_error": "Javob bekor qilishda xatolik",
                "delete_question_confirmation": "Ushbu savolni o'chirishga ishonchingiz komilmi?",
                "withdraw_answer_confirmation": "Ushbu javobni qaytarishga ishonchingiz komilmi?",
                "withdraw_answer_action": "Qaytarish",
                "cancel_title": "Javobni bekor qilish",
                "delete_title": "Savolni o'chirish",
                "profile_loading_error": "Profilni yuklashda xatolik 😔",
                "should_try_reload": "Dasturni qayta yuklashni urinib ko'ring",
                "repeat": "Takrorlash",
                "share_profile_owner_text": "Ushbu havola orqali menga anonim savol berishingiz mumkin!",
                "share_profile_text": "Ushbu havola orqali anonim savol berishingiz mumkin!\n{{first_name}} {{last_name}}",
                "anonymous": "Anonim",
                "questions_from_you": "Sizning berdingiz savollar",
                "update_profile_photo_title": "Profil rasmini yangilash",
                "save_photo": "Rasmini saqlash",
                "profile_photo_updated": "Profil rasmi yangilandi",
                "profile_photo_update_error": "Profil rasmini yangilashda xatolik",
                "select_file": "Faylni tanlash",
                "unknown_error": "Noma'lum xatolik",
                "share_answer": "Javobni ulashish",
                "sent": "Yuborildi",
                "answer_from_bot": "@askerixbot dan javob",
                "subscribe": "Obuna bo'lish",
                "unsubscribe": "Obunani bekor qilish",
                "subscribed": "Yangi foydalanuvchi javoblari haqida bildirishnomalarga obuna bo'ldingiz",
                "unsubscribed": "Yangi foydalanuvchi javoblari haqida bildirishnomalardan obunani bekor qildingiz",
                "still_not_answered": "{{first_name}} hali qanday javob berishini ko'rib turgan",
                "asked_questions": "Savol berdingiz savollar",
                "function_not_supported": "Bu funktsiya hali to'g'ri ishlamayapti",
                "sent_by_bot": "Bot xabari orqali yuborildi",
            }
        },
    },
    lng: lang,
});
